import { SEO_TITLE_STROLLERS, STROLLER_SEO_GENERAL_DESC, STROLLER_WISHLIST_BUTTON } from 'mk/autogenerated/translations/BrandsListPage.5deb64fe56d74e5977ffffaff3041668'
import Icon from 'mk/bazaar/common/components/Icon';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import { ArticleEntity, ArticleSchema } from 'mk2/apps/blogs/schemas';
import { CounsellingEntity, CounsellingSchema } from 'mk2/apps/forum/schemas';
import BrandsList from 'mk2/apps/strollers/containers/BrandsList/BrandsList';
import { brandsFetchTrigger } from 'mk2/apps/strollers/containers/BrandsList/BrandsList.actions';
import brandsReducer from 'mk2/apps/strollers/containers/BrandsList/BrandsList.reducers';
import brandsSaga from 'mk2/apps/strollers/containers/BrandsList/BrandsList.sagas';
import {
    getStrollerBrandsListItems,
    getStrollerBrandsListState,
} from 'mk2/apps/strollers/containers/BrandsList/BrandsList.selectors';
import { strollersWishlistIdsLoad } from 'mk2/apps/strollers/containers/WishList/WishList.actions';
import wishListReducer from 'mk2/apps/strollers/containers/WishList/WishList.reducers';
import wishListSaga from 'mk2/apps/strollers/containers/WishList/WishList.sagas';
import { getStrollersWishListState } from 'mk2/apps/strollers/containers/WishList/WishList.selectors';
import { BrandEntity } from 'mk2/apps/strollers/schemas';
import { strollersWishlistUrl } from 'mk2/apps/strollers/urls';
import Link from 'mk2/components/Link';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { url } from 'mk2/helpers/urls';
import Page, { HalfpageProps } from 'mk2/pages/Page';
import { AppState } from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { getDenormalizedEntities, getDenormalizedEntity } from 'mk2/selectors';
import { Store } from 'mk2/store/configureStore';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import styles from './BrandsList.mscss';

interface OwnProps {
}

interface StateProps {
    items: BrandEntity[];
    hasMore: boolean;
    loadingState: LoadingState;
    errorMessage: string;
    wishlist: string[];
    strollersCounselling: CounsellingEntity;
    guideArticles: ArticleEntity[];
}

interface DispatchProps {
    onLoad(after?: string);
    onWishlistIdsLoad();
}

type RouteProps = RouteComponentProps<{}>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class BrandsListPage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const brandsListState = getStrollerBrandsListState(state);
            const wishlistState = getStrollersWishListState(state);

            return {
                errorMessage: brandsListState.errorMessage,
                loadingState: brandsListState.loadingState,
                items: getStrollerBrandsListItems(state),
                hasMore: brandsListState.hasMore,
                wishlist: wishlistState.currentWishlist,
                guideArticles: getDenormalizedEntities<ArticleEntity>(state, ArticleSchema, brandsListState.guideArticleIds),
                strollersCounselling: getDenormalizedEntity<CounsellingEntity>(state, CounsellingSchema, brandsListState.strollersCounsellingId),
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onLoad: brandsFetchTrigger,
            onWishlistIdsLoad: strollersWishlistIdsLoad,
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_STROLLERS;
    }

    public getMetaDescription(props: Props): string {
        return STROLLER_SEO_GENERAL_DESC;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <BrandsList {...props} />
        );
    }

    public getHeaderLeft(props: Props): JSX.Element {
        return (
            <Link to={url(strollersWishlistUrl, {})} className={styles.BrandsList__leftButton}>
                <Icon icon="fa-star-o" />&nbsp;
                {STROLLER_WISHLIST_BUTTON}
                {props.wishlist.length > 0 && (
                    <span className={styles.BrandsList__leftButton__number}> ({props.wishlist.length})</span>
                )}
            </Link>
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public getHalfpageProps(props: Props): HalfpageProps {
        return {
            zone: 'Strollers Index - Halfpage Sticky (Desktop)',
        };
    }

    public hasMobileLogo(props: Props): boolean {
        return ACTIVE_SERVER_ID === 207 ? false : true;
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.strollers.brandsList', brandsReducer);
        store.injectSaga('containers.strollers.brandsList', brandsSaga);

        store.injectReducer('containers.strollers.wishList', wishListReducer);
        store.injectSaga('containers.strollers.wishList', wishListSaga);
    }
}
